import { FC, PropsWithChildren } from "react";

import Stack from "@mui/material/Stack";

import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";

interface TranslationCardProps {
  title: string;
}

export const TranslationCard: FC<PropsWithChildren<TranslationCardProps>> = ({ title, children }) => (
  <Stack
    gap={2}
    sx={(theme) => ({
      padding: 2,
      boxShadow: `inset 0 0 0 1px ${theme.palette.border.neutral.quiet}`,
      borderRadius: theme.radius(1),
      backgroundColor: theme.palette.surface.neutral.white,
      minWidth: 0,
    })}
  >
    <DashboardTypography variant="subtitle1" vibe="text-neutral-moderate" sx={{ overflowWrap: "anywhere" }}>
      {title}
    </DashboardTypography>
    {children}
  </Stack>
);
